import(/* webpackMode: "eager" */ "/app/components/image-overlay.css");
;
import(/* webpackMode: "eager" */ "/app/components/LazyImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlocksRenderer"] */ "/app/node_modules/.pnpm/@strapi+blocks-react-renderer@1.0.2_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/@strapi/blocks-react-renderer/dist/BlocksRenderer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.3.4_next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0_typescript@5.8.2/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.3.4_next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0_typescript@5.8.2/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/templates/about-us/facility-highlight.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/amenities/amenities.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/amenities/highlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/templates/banner.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/error.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/templates/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/homepage/amenities.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/templates/homepage/banner-list.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/homepage/kpa-simulation.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/homepage/unit-type.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/info-promo/facility-thumbnail.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/login/banner.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/login/cdc.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BASE_FILTER_NEWS","filters","default"] */ "/app/templates/news-event/client.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/news-event/detail/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/news-event/search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/templates/not-found.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/sales/detail.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/submission.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/unit-type/comparation/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/templates/unit-type/unit-type-tower.tsx");
